import creator from "../creator";

export default function(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/append.js
// module id = 1201
// module chunks = 1